<template>
  <div :class="['comp-ly-table', { 'sub-ly-table': type == 35 }]" ref="lyTableRef">
    <qf-table :tableSkeletonRows="5" :errorRowList="errorRowList" v-if="data.columns?.length" activeRowType="single" expandType="single" row-key="id" ref="qfTableRef" :columns="data.columns" :data="tableData" :hasPagination="type == 35 ? false : true" :pagination="tableData?.length ? pagination : false" :bordered="false" @paginationEvent="paginationEvent" :expand-icon="expandLevel1Icon" @expand-change="rehandleExpandChange" :cornerMark="true" :activeRowKeys="activeRowKeys" :expandedRowKeys="expandedRowKeys" :checkedParams="{ width: 60 }" :summaryOptions="summaryOptions" @summaryChange="summaryChange">
      <!-- <template #empty>
        <jw-empty :img-src="noDataSvg" :description="'暂无数据'"></jw-empty>
      </template> -->

      <template #operations="{ row }">
        <div class="operation-button" @click.stop="">
          <template v-if="buttonShortcut?.length && row?.LOGIC_ROLE_PERMISSION && row?.LOGIC_ROLE_PERMISSION == 1">
            <ly-list-shortcut-buttons :computedStatus="row?.computedInfo?.status" :viewId="tableColumns[0]?.parentId" :entityId="getTableLevelEntity()" :fieldsListAll="buttonShortcut" :recordObj="row" @cb="shortcutBtnCb(1)"></ly-list-shortcut-buttons>
          </template>

          <div v-else>-</div>
        </div>
      </template>

      <template #cornerMark="{ row }">
        <template v-if="row?.computedInfo?.status == 2">
          <ly-computed-icon-tips :computedInfo="row?.computedInfo" />
        </template>
      </template>

      <!-- 自定义固定列 -->
      <template #customCheckbox="{ row, index }">
        <div class="computed-status-container" :class="[{ 'show-refresh-icon': computingStatus.includes(row?.computedInfo?.status) }]">
          <jw-tooltip :content="row?.computedInfo?.status === 1 ? '计算处理中' : '审批处理中'">
            <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin @click="refreshComputedStatus([row.id])" class="computed-status-icon" />
          </jw-tooltip>
        </div>

        <div class="index-container">
          <div class="index-num" :class="{ 'show-detail-icon': !isSpecialProduct }">{{ index + 1 }}</div>

          <jw-tooltip content="查看详情" v-if="type != 35 && !isSpecialProduct">
            <div class="index-detail-icon" @click.stop="toDetails(row)">
              <qfei-icon-full-screen-outlined />
            </div>
          </jw-tooltip>
        </div>
      </template>

      <!-- 字段图标 -->
      <template #prefix="{ col }">
        <component :is="getFieldIcn(col)" v-if="col.colKey !== 'operations'" />
      </template>

      <!-- 展开收起 -->
      <template #expandIcon="{ rowKey }">
        <div class="fh-table-expand-icon">
          <qfei-icon-caret-right-outlined v-if="!expandedRowKeys.includes(rowKey)" style="font-size: 10px" />
          <qfei-icon-caret-down-outlined v-else style="font-size: 10px" />
        </div>
      </template>

      <!--加载多层级内容(二级) -->
      <template #expandRow="{ row }">
        <fh-detail-nest-table :isCanEdit="isEditComputed" :currentKey="currentKey" :parentEntity="entity" :multiTable="multiTable" :parentId="row?.id" />
      </template>
    </qf-table>
    <template v-else>
      <fh-list-skeleton :rows="5" :columns="5" />
    </template>
    <!--主对象公共详情  S-->
    <ly-detail ref="detailRef" mask @cb="refreshList('detail')"></ly-detail>
  </div>
</template>

<script setup lang="jsx">
import { reactive, onBeforeUnmount, onUnmounted, ref, watch, inject, onMounted, provide, computed, nextTick } from 'vue';

import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';

import { QfeiIconCaretRightOutlined, QfeiIconCaretDownOutlined, QfeiIconFullScreenOutlined } from '@qfei-design/icons-vue';
import { fieldAggregationService, publicService, setService } from '@/api/';
import { tools } from '@/utils/tools';
import FhDetailNestTable from '../fh-detail-nest-table/fh-detail-nest-table.vue';
// import dayjs from 'dayjs';
import { objectRoleEnum, computingStatus } from '@/utils/const';
import useEventListener from '@/hooks/event-listener';
import { useLyTableConfig, useComputedStatusPolling } from '@/hooks/ly-table-config';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import useFields from '@/hooks/fields';
import { isAggregationField } from '../table/utils';
import { summaryStatus } from '../table/contants';

const { fieldIconMapping } = useFields(); // 获取字段图标
const { eventListener } = useEventListener();
const getSummaryTimer = null;
const props = defineProps({
  column: {
    type: Array,
    default: () => []
  },
  list: {
    type: Array,
    default: () => []
  },
  layoutConfigId: {
    type: [Number, String]
  },
  businessData: {
    type: [Number, String]
  },
  businessEntity: {
    //只有子表时会上传
    type: [Number, String]
  },
  layoutId: {
    type: [Number, String]
  },
  type: {
    //30:表格 35：子表
    type: [Number, String],
    default: 30
  },
  //规则配置是否可编辑 适配嵌套表格
  isCanEdit: {
    type: Boolean,
    default: true
  },
  subformFieldKey: {
    type: String,
    default: ''
  },
  subformRuleFields: {
    type: Object,
    default: () => {
      return null;
    }
  },
  attributeRead: {
    type: Array,
    default: () => []
  },
  tId: {
    type: Number
  }
});

const { t } = useI18n();

const isEditComputed = computed(() => {
  return props.isCanEdit;
});
const businessId = ref(inject('detailParams').id);

/*
7-报价单产品
9-合同产品
11-销售订单产品
14-退货单产品
32-商机产品
*/

const specialProductList = ['7', '9', '11', '14', '32'];

const isSpecialProduct = computed(() => {
  return specialProductList.includes(props.businessData + '');
});

const getFieldIcn = (field) => {
  if (!field || field?.slotName == 'operations') return null;
  return fieldIconMapping.value[Number(field?.fieldType || 0)];
};

const multiTable = computed(() => {
  return props.column?.find((list) => list.type == 31);
});
const currentKey = tools.randomString();

//类型1-线索 2-客户 3-商机 4-产品 6--报价单详情 7--报价单明细 8 销售合同 9 销售合同明细10销售订单13退货单14退货单产品

const entity = computed(() => {
  return props.type == 35 ? props.businessEntity : props.businessData;
});
const businessData2 = computed(() => {
  return props.column?.filter((list) => list.type == 31)?.[0]?.businessData;
});
const businessData3 = computed(() => {
  return props.column?.filter((list) => list.type == 31)?.[0]?.modules?.filter((item) => item.type == 31)?.[0]?.businessData;
});

const viewTabRef = ref();

const tableData = ref([]);

const detailsDrawer = ref(null); // 详情页弹窗
const detailsDrawerZIndex = ref(0); // 详情页弹窗z-index

const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  foldedMaxPageBtn: 2,
  maxPageBtn: 4,
  showPageSize: true, // 是否显示数据条数选择器
  showJumper: true,
  size: 'small',
  pageSizeOptions: [10, 20, 50],
  showTotal: true // 是否显示数据总数
});

const data = reactive({
  id: null,
  specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
  tableList: [],
  columns: [],
  tableLevel2Modules: [], //二层级modules
  tableLevel2Columns: [], //二层级表头信息
  tableLevel2Data: [], //二层级表格数据
  tableLevel2RowData: {}, //点击展开行时当前条数据
  tableLevel3Modules: [], //三层级modules
  tableLevel3Columns: [], //三层级表头信息

  tableLevel3Data: [], //三层级表格数据
  tableLevel3RowData: {}, //点击展开行时当前条数据
  tableLevel: '', //表格层级（2/3）
  getTableLevel1Width: 0, //一级表格的宽度

  activeRow: true,
  activeId: null,

  globalEntity: null,
  slots: ['intentionality', 'customerLevel', 'clueStatus', 'isImportant', 'qccId', 'isDealt', 'important', 'lastFollowContent', 'amount', 'isExistContract', 'fsContractId', 'esignStatus', 'totality', 'billPeriod'] //插槽的列表
});
const { getTableLevelColumns, assTableData } = useLyTableConfig(entity, 1, props.type);

const { startPolling, refreshComputedStatus, clearTimer, errorRowList } = useComputedStatusPolling({
  tableData,
  entity,
  viewId: computed(() => data.viewId || props.viewId),
  tId: props.tId
});

const detailRef = ref(); //公共抽离组件
const lyTableRef = ref(null); //容器
//是否显示汇总行
const summaryOptions = reactive({
  enabled: +props.type === 30,
  data: {},
  formatter: (...args) => tools.formatSummary(...args)
});

const getBaseParams = () => {
  return {
    itselfTableEntity: getObjEntity(),
    tableEntity: getTableLevelEntity(),
    layoutId: props.layoutId,
    layoutConfigId: props.layoutConfigId,
    businessId: businessId.value
  };
};

// 汇总
const getSummaryData = async () => {
  console.log('getSummaryData', summaryOptions);
  if (!summaryOptions.enabled) return;
  resetSummaryData();
  const res = await fieldAggregationService.getTableAggregation(getBaseParams(), Math.random());
  if (!res.error) {
    const result = res.result || {};
    Object.keys(summaryOptions.data).forEach((key) => {
      summaryOptions.data[key] = result[key] == null ? summaryStatus.error : result[key];
    });
  } else {
    console.error(res.error?.msg);
  }
};

const summaryChange = async (val) => {
  const { fieldKey, type } = val;
  const target = data.columns?.find((x) => x.colKey === fieldKey);
  if (target) {
    const oldType = target.aggregationType;
    const oldValue = summaryOptions.data[fieldKey];
    const onError = () => {
      target.aggregationType = oldType;
      summaryOptions.data[fieldKey] = oldValue;
    };

    target.aggregationType = type;
    summaryOptions.data[fieldKey] = summaryStatus.loading;
    try {
      const res = await fieldAggregationService.updateAndGetTableAggregation({
        ...getBaseParams(),
        aggregation: {
          fieldKey,
          type
        }
      });
      if (!res.error) {
        summaryOptions.data[fieldKey] = res.result[fieldKey] ?? summaryStatus.error;
      } else {
        Message.error(res.error?.msg || t('操作失败'));
        onError();
      }
    } catch (e) {
      console.error(e);
      onError();
    }
  }
};
// 查找关联跳转详情
const toDetails = (record) => {
  console.log(229, record, entity.value);

  let getGlobalEntity = props.businessData; //主对象
  getGlobalEntity = getTableLevelEntity();

  if (data.specialProduct.includes(Number(getGlobalEntity))) {
    //特殊产品显示不能点击状态
    return false;
  }
  data.id = record.id;
  data.tableLevel = record?.tableLevel || '';
  data.globalEntity = getGlobalEntity;
  detailRef.value.openDialog();
};
// 快捷组件中按钮的回调
const shortcutBtnCb = (type) => {
  getTableEntityData(type);
};
console.log(shortcutBtnCb);
const loadingObj = ref({});
// 如果需要列选择，就需要在自己需要的地方自定义一个按钮，实现table的这个事件 开始 S
const qfTableRef = ref(null); // 表格ref

const tableColumns = computed(() => {
  return props.column
    .filter((v) => v.type != 40 && v.type != 31)
    .map((v) => {
      return {
        id: v.id,
        setting: v.setting,
        ...v.setting,
        businessData: v?.businessData,
        modules: v.modules,
        aggregationType: v.aggregationType
      };
    });
});
const buttonShortcut = ref(
  props.column
    .filter((v) => v.type == 40 && v?.value != (props.businessData < 200 ? objectRoleEnum[props.businessData] + ':add' : props.businessData + ':add'))
    .map((n) => {
      return n.value;
    })
);
const buttonShortcut2 = ref(
  props.column
    ?.filter((list) => list.type == 31)?.[0]
    ?.modules?.filter((v) => v.type == 40 && v?.value != (businessData2.value < 200 ? objectRoleEnum[businessData2.value] + ':add' : businessData2.value + ':add'))
    .map((n) => {
      return n.value;
    })
);
const buttonShortcut3 = ref(
  props.column
    ?.filter((list) => list.type == 31)?.[0]
    ?.modules?.filter((item) => item.type == 31)?.[0]
    ?.modules?.filter((v) => v.type == 40 && v?.value != (businessData3.value < 200 ? objectRoleEnum[businessData3.value] + ':add' : businessData3.value + ':add'))
    .map((n) => {
      return n.value;
    })
);

const operationItem = computed(() => {
  return buttonShortcut.value?.length === 0 ? 0 : buttonShortcut.value?.length <= 3 ? 160 : 180;
});
const operationItem2 = computed(() => {
  return buttonShortcut2.value?.length === 0 ? 0 : buttonShortcut2.value?.length <= 3 ? 160 : 180;
});
const operationItem3 = computed(() => {
  return buttonShortcut3.value?.length === 0 ? 0 : buttonShortcut3.value?.length <= 3 ? 160 : 180;
});
// 商机产品、报价单产品、合同产品、退货单产品等等
// const productList = [7, 9, 11, 14, 32];
// 获取主属性字段
// const detailKey = () => {
//   //第一级
//   return props.column?.filter((v) => v.setting?.mainField && !productList.includes(v.setting.entityId))?.find((pc) => pc?.setting?.mainField)?.setting?.fieldKey || 'name';
// };
// 给多级表格加动态宽度
const setClientWidth = (getClassName, minus) => {
  nextTick(() => {
    const getTableLevel1Width = document.querySelector(`.table-${currentKey}-content`)?.offsetWidth;
    const tableLevel1Content = document.querySelector(getClassName);
    if (tableLevel1Content) {
      const expandedRowInner = tableLevel1Content.querySelector('.t-table__expanded-row-inner');
      if (expandedRowInner) {
        // 动态设置宽度
        expandedRowInner.style.width = getTableLevel1Width - minus + 'px'; // 你可以将 '890px' 替换为动态计算的值
        console.log('设置宽度111', getTableLevel1Width - minus);
      } else {
        console.log('未找到 .t-table__expanded-row-inner 元素');
      }
    } else {
      console.log('未找到 .table-level-1-content 元素');
    }
  });
};
//多层级获取对象
const getTableLevelEntity = () => {
  return entity.value || '';
};
// 是否开启多层级表格（一级）
const expandLevel1Icon = computed(() => {
  return props.column?.filter((list) => list.type == 31)?.[0]?.modules?.length > 0 ? true : false;
});

const expandedRowKeys = ref([]); //一级存储展开行的值
//点击展开图标(加载二级)
const rehandleExpandChange = ({ expandRowKeys }) => {
  expandedRowKeys.value = [];
  if (expandRowKeys && expandRowKeys?.length) {
    // 更新展开状态
    expandedRowKeys.value.push(expandRowKeys[expandRowKeys.length - 1]);
  }
};

// 表格的render抽离 isEdit:列表是否走编辑逻辑。多层级表格不支持编辑

// 创建操作列配置
const createOperationColumn = (type) => ({
  colType: false,
  colKey: 'operations',
  slotName: 'operations',
  title: '操作',
  stopPropagation: true,
  fixed: 'right',
  width: type == 1 ? operationItem.value : type == 2 ? operationItem2.value : operationItem3.value
});

const objEntity = ref(inject('detailParams').entity);

const refreshList = (tp) => {
  if (tp === 'detail') {
    console.log(996, '关闭弹窗');
  } else {
    getTableEntityData(tp);
  }
};
// 获取计算错误数据
const getComputedErrorLog = async (businessIdList, entityParams) => {
  try {
    const json = await setService.getComputedErrorLog({
      entity: entityParams,
      businessIdList: businessIdList,
      //2025年06月26日18:39:50 zl 防止关联同一个对象，所以使用对象-随机数
      apiIndex: `${entityParams}-${Math.random()}`
    });
    if (!json.error) {
      const result = json.result;
      return result;
    }
  } catch (error) {
    console.log(error);
  }
};

const getObjEntity = () => {
  return objEntity.value; // 最外层表格
};

// 获取表格数据
const getTableEntityData = async () => {
  // 动态控制loading显示状态
  loadingObj.value[props.layoutConfigId] = true;
  // 清空定时器 每次分页请求 清空上一页定时器
  clearTimer();
  if (props.type != 35) {
    //子表不请求接口
    const baseParams = getBaseParams();
    const { getBusinessId, tableEntity, layoutId, layoutConfigId } = baseParams;
    const params = {
      ...baseParams,
      page: pagination.value.current,
      pageSize: pagination.value.pageSize,
      apiIndex: `${tableEntity}_${layoutId}_${layoutConfigId}_${getBusinessId}`
    };
    try {
      const res = await publicService.getTableEntityData(params);
      if (!res.error) {
        const rt = res.result;
        // tableData.value = rt.records;
        //一级表格
        const businessIdList = rt.records?.map((dItem) => dItem.id);

        const computedInfo = await getComputedErrorLog(businessIdList, tableEntity);
        tableData.value = assTableData(rt.records, computedInfo);
        if (tableData.value.length) {
          startPolling();
        }

        pagination.value = {
          ...pagination.value,
          current: rt.current,
          total: rt.total
        };
      }
      loadingObj.value[props.layoutConfigId] = false;
      loadingObj.value[getBusinessId] = false;
    } catch (e) {
      loadingObj.value[props.layoutConfigId] = false;
      loadingObj.value[getBusinessId] = false;
      console.log(e);
    }
  } else {
    tableData.value = props.list; //子表单数据
    loadingObj.value[props.layoutConfigId] = false;
  }
};

const paginationEvent = async (page, pageSize) => {
  pagination.value.pageSize = pageSize;
  pagination.value.current = page;
  await getTableEntityData(1);
};

const resetSummaryData = () => {
  summaryOptions.data = data.columns.reduce((pre, item) => {
    if (isAggregationField(item.fieldType, item.fieldExt)) {
      pre[item.colKey] = summaryStatus.loading;
    }
    return pre;
  }, {});
};

const tableInitFn = async () => {
  console.log('表格触发初始化init');
  buttonShortcut.value = props.column
    .filter((v) => v.type == 40 && v?.value != props.businessData + ':add')
    .map((n) => {
      return n.value;
    });
  data.columns = getTableLevelColumns(tableColumns.value, tableData, null, props.subformRuleFields, props.subformFieldKey);
  resetSummaryData();
  const btnValue = props.businessData < 200 ? objectRoleEnum[props.businessData] + ':add' : props.businessData + ':add';

  if (props?.type != 35) {
    //子表单不增加操作列

    if (props.column.filter((v) => v.type == 40 && v?.value != btnValue)?.length) {
      // 操作列
      data.columns.push(createOperationColumn(1));
    }
  }
  console.log('tttttttttt');
  await getTableEntityData(1);
  console.log('ttttt');
  getSummaryData();
};

//动态调整内容宽度
eventListener('resize', () => setClientWidth(`.table-${currentKey}-content`, 16));
watch(
  () => props.column,
  () => {
    tableInitFn();
  },
  {
    deep: true
    // immediate: true
  }
);
const tableScrollEvent = async (params) => {
  //例如： params = { direction: 'left', distance: 100 };
  if (qfTableRef.value) {
    qfTableRef.value?.tableScrollEvent(params);
  }
};

// 获取左侧固定列最后一列到视口左侧的距离

// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (!qfTableRef.value) return;
  qfTableRef.value?.updateZIndex({ rowKey, zIndex });
};

// 获取展示容器
const getShowBodyRef = () => {
  return lyTableRef.value;
};

// 获取表格滚动容器的实例方法
const getScrollContainerRef = () => {
  console.log('表格滚动实例', qfTableRef.value);

  return qfTableRef.value?.qfTableScrollContainerRef;
};

// 获取表格实例
const getTableBodyRef = () => {
  const dom = qfTableRef.value?.qfTableBodyRef;
  return dom;
};

// 获取Qf-table的表头实例方法
const getTableHeaderRef = (level = 1) => {
  return qfTableRef.value?.getTableHeaderRef(level);
};

// 获取左侧固定列最后一列到视口左侧的距离

const getFixedLeftLastCellRect = (level = 1) => {
  const elements = lyTableRef.value?.querySelectorAll('.qf-table-header-fixed-left-last');

  if (elements?.length) {
    const rect = elements[level - 1]?.getBoundingClientRect();
    return rect;
  }
  return null;
};

const tableScrollToTop = (params) => {
  console.log(5661, params);
  qfTableRef.value?.scrollToTop(params);
};
onMounted(() => {
  // 获取挂载的抽屉容器
  if (props.column?.length) {
    tableInitFn();
  }
  const getAditPopup = document?.querySelectorAll('.obj-details-drawer');
  if (getAditPopup && getAditPopup?.length > 0) {
    detailsDrawerZIndex.value = Number(getAditPopup[getAditPopup?.length - 1].style.zIndex) + 1;
    detailsDrawer.value = getAditPopup[getAditPopup?.length - 1];
  }
});

provide('rootDrawer', {
  detailsDrawer: computed(() => detailsDrawer.value),
  detailsDrawerZIndex: computed(() => detailsDrawerZIndex.value)
});

provide('globalParams', {
  id: computed(() => data.id),
  entity: computed(() => data.globalEntity),
  columns: computed(() => data.columns),

  viewId: -1
});

provide('mainTableMethods', {
  getShowBodyRef: getShowBodyRef,
  getTableBodyRef: getTableBodyRef,
  getTableHeaderRef: getTableHeaderRef,
  tableScrollToTop: tableScrollToTop,
  toDetails: toDetails,
  getScrollContainerRef: getScrollContainerRef
});

provide('defaultParams', {
  id: computed(() => data.id),
  entity: computed(() => entity.value),
  viewId: computed(() => data.viewId), //兼容多层级表格
  // poolId: computed(() => poolId.value),
  columns: computed(() => data.columns || []),
  isSpecialProduct: computed(() => isSpecialProduct.value)
  // keywords: computed(() => keywords.value), // 搜索值
  // searchFieldsList: computed(() => searchFieldsList.value) // 搜索字段
});

provide('tableMethods', {
  tableScrollEvent: tableScrollEvent,
  getFixedLeftLastCellRect: getFixedLeftLastCellRect,

  updateZIndex: updateZIndex
});

onBeforeUnmount(() => {
  clearTimer();
});

// 确保所有定时器都被清理
onUnmounted(() => {
  clearTimer();
  clearTimeout(getSummaryTimer);
});

defineExpose({ toDetails, viewTabRef, getTableEntityData });
</script>
<style scoped lang="less">
@import './fh-detail-table.less';
</style>
